<template>
  <div>
    <list-vue
      v-bind:busqueda="busqueda"
      v-bind:busquedaTraduccion="busquedaTraduccion"
      v-bind:busquedaMedidas="busquedaMedidas"
      v-bind:opciones="opciones"
      v-bind:moduloTitulo="moduloTitulo"
      v-bind:pantallaTitulo="pantallaTitulo"
      v-bind:rutaConsulta="rutaConsulta"
      v-bind:buttonsPage="buttonsPage"
      v-bind:busquedaCampos="busquedaCampos"
    ></list-vue>
  </div>
</template>
  <script type="text/javascript">
import { mapState } from "vuex";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      //Definimos los nombres generales
      moduloTitulo: this.$root.trans("Tabla de Campos Adicionales de Etapas"),
      reporte: false,
      pantallaTitulo: this.$root.trans("Resultado"),
      rutaConsulta: this.$route.fullPath,
      buttonsPage: [
        {
          type: "button",
          class: "btn btn-xs btn-info pull-right",
          route: "AuthorsCreate",
          text: '<i class="fa fa-plus">',
          external:
            "../../../../../tablacamposadic.php?filtroTipoNC=RE",
        },
      ],
      //Definimos los campos de busqueda, sus nombres e incluso tamaño
      busqueda: {
        orden_nro: "",
        descripcion: "",
        tipo_dato: "",
        longitud: "",
        canti_decim: "",
        marca_obliga: "",
        etapa_codi: "",
        tipo_nc_codi: "",
        estado: "",
      },
      busquedaTraduccion: {
        orden_nro: this.$root.trans("Orden"),
        descripcion: this.$root.trans("Descripción"),
        tipo_dato: this.$root.trans("Tipo Dato."),
        longitud: this.$root.trans("Longitud"),
        canti_decim: this.$root.trans("Decimales"),
        marca_obliga: this.$root.trans("Obliga Observ."),
        etapa_codi: this.$root.trans("Etapa"),
        tipo_nc_codi: this.$root.trans("Tipo"),
        estado: this.$root.trans("Estado"),
      },
      busquedaCampos: {
        estado: {
          type: "select",
          options: [
            { label: "Activo", code: "A" },
            { label: "Desactivado", code: "B" },
          ],
        },
        etapa_codi: {
          type: "select",
          options: [],
        },
        tipo_nc_codi: {
          type: "select",
          options: [],
        },
        tipo_dato: {
          type: "select",
          options: [
            { code: "C", label: "Texto" },
            { code: "N", label: "Nro Entero" },
            { code: "T", label: "Tabla" },
            { code: "D", label: "Nro Decimal" },
            { code: "E", label: "Fecha" },
            { code: "K", label: "Check" },
            { code: "M", label: "Memo" },
            { code: "F", label: "Ficha" },
            { code: "O", label: "Proceso" },
            { code: "P", label: "Procedimiento" },
            { code: "U", label: "Usuario" },
            { code: "Z", label: "Correcciones Normativa" },
            { code: "X", label: "Matriz" },
          ],
        },
        marca_obliga: {
          type: "select",
          options: [
            { code: "S", label: "Si" },
            { code: "N", label: "No" },
          ],
        },
      },
      busquedaMedidas: {
        orden_nro: "80px",
        descripcion: "",
        horas_resoluc_defecto: "80px",
        tipo_dato: "130px",
        longitud: "100px",
        canti_decim: "100px",
        marca_obliga: "110px",
        etapa_codi: "180px",
        tipo_nc_codi: "180px",
        estado: "130px",
      },
      //definimos las opciones con enlace simple para ello usamos el nombre de la ruta y en caso de eliminar usamos la ruta
      opciones: [
        // {
        //   class: "btn btn-sm btn-warning",
        //   icon: "fas fa-edit",
        //   routerName: "TiposRegistroEdit",
        //   param: "codigo",
        //   eliminar: false,
        //   nombre: "Editar",
        // },
      ],
    };
  },
  computed: {
    ...mapState(["request"]),
  },
  methods: {
    ...mapMutations({ requestSet: "request" }),
  },
  mounted() {
    this.requestSet(this.$route.query);
  },
  created() {
    this.requestSet(this.$route.query);

    const data = {
      selects: {
        // User: {},
        TipoNC: { categoria_nc: "RE", estado: "all" },
        generic1: {
          code: "descripcion",
          label: "descripcion",
          model: "FichasEtapaNC",
          order: "descripcion",
          nc: "RE",
        },
      },
    };
    this.$root
      .Consulta(
        this.$root.UrlBase("selects/init"),
        data,
        "post",
        false,
        false,
        false,
        "",
        false
      )
      .then((response) => {
        this.busquedaCampos.tipo_nc_codi.options = response.TipoNC;
        this.busquedaCampos.etapa_codi.options = response.generic1;
      });
  },
};
</script>
